import React from 'react'

const VaultContext = React.createContext()

export default VaultContext
